import { BaseModel } from "../../core/classes/BaseModel";
import { ApiAsync } from "../../core/classes/ApiAsync";

export class SurveyVote extends BaseModel {
  constructor(params) {
    super(params);
  }

  $fields() {
    return ["id", "user_id", "survey_id"];
  }
}
